import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChainLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChainLink2"><Path d="M6.5 11.5H6V12.5H6.5V11.5ZM17.5 12.5H18V11.5H17.5V12.5ZM22.5 6.5H23V6H22.5V6.5ZM22.5 17.5V18H23V17.5H22.5ZM15.5 17H15V18H15.5V17ZM15.5 6H15V7H15.5V6ZM1.5 6.5V6H1V6.5H1.5ZM1.5 17.5H1V18H1.5V17.5ZM8.5 18H9V17H8.5V18ZM8.5 7H9V6H8.5V7ZM6.5 12.5H17.5V11.5H6.5V12.5ZM22 6.5V17.5H23V6.5H22ZM22.5 17H15.5V18H22.5V17ZM15.5 7H22.5V6H15.5V7ZM1 6.5V17.5H2V6.5H1ZM1.5 18H8.5V17H1.5V18ZM8.5 6H1.5V7H8.5V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChainLink2;
